var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Page",
    [
      _c(
        "template",
        { slot: "header-left-dropdown" },
        [
          _c("PageTabButtons", {
            attrs: {
              selectedList: _vm.requestHeaderLinks,
              translationGroup: "Request",
            },
          }),
        ],
        1
      ),
      _c(
        "template",
        { slot: "header-left-search" },
        [
          _c("Search", {
            staticClass: "search-box",
            attrs: {
              componentName: "approvedOrder",
              suggestionValue: "name",
              isSuggestionLoading: _vm.isSuggestionLoading,
              suggestions: _vm.selectedStockItem,
              customSuggestionPlaceHolder: _vm.$t(
                "Orders.orders_search_Placeholder"
              ),
              customSuggestionTitle: _vm.$t(
                "Orders.orders_search_SuggestionTitle"
              ),
            },
            on: {
              onChangeSearchValue: _vm.onChangeSearch,
              onChangeQueryItem: _vm.setStockItem,
              clearSearch: _vm.clearSearch,
            },
          }),
        ],
        1
      ),
      _c("template", { slot: "header-right-dropdown" }, [
        _vm.hasTabPermission
          ? _c("div", { staticClass: "right" }, [
              _c(
                "div",
                {
                  staticClass: "form-item-select date-start",
                  attrs: { id: "date-start-request-order-list" },
                },
                [
                  _c("CustomDatepicker", {
                    attrs: {
                      isLoading: _vm.$wait.is("getDateFilterSettings"),
                      id: "custom-datepicker-request-order-list",
                      range: true,
                    },
                    model: {
                      value: _vm.dates,
                      callback: function ($$v) {
                        _vm.dates = $$v
                      },
                      expression: "dates",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "template",
        { slot: "toolbar-left" },
        [
          _c("CustomMultiselect", {
            ref: "approvedOrderStoreFilter",
            staticClass: "toolbar-filters__item",
            attrs: {
              id: "approved-order-store-filter",
              items: _vm.storeList,
              showCountBadge: false,
              selected: _vm.storeFilter,
              label: _vm.$t("ABCAnalysis.toolbar_Stores_Label"),
              unselectedText: _vm.$t("ABCAnalysis.toolbar_Stores_Unselected"),
              popupHeader: _vm.$t("Global.toolbar_Stores_PopupHeader"),
              allLabel: _vm.$t("ABCAnalysis.toolbar_Stores_AllLabel"),
              buttonText: _vm.$t("ABCAnalysis.toolbar_Stores_ButtonText"),
              buttonIconLeft: "btn-success",
            },
            on: {
              delegateCheckAll: _vm.onChangeStoreFilter,
              delegateCheckItem: _vm.onChangeStoreFilter,
              delegateSubmitItems: _vm.submitFilters,
            },
          }),
          _c("CustomMultiselect", {
            ref: "approvedOrderSupplierFilter",
            staticClass: "toolbar-filters__item",
            attrs: {
              id: "approved-order-supplier-filter",
              items: _vm.supplierList,
              showCountBadge: false,
              selected: _vm.supplierFilter,
              label: _vm.$t("Global.toolbar_Supplier_Label"),
              popupHeader: _vm.$t("Global.toolbar_Supplier_PopupHeader"),
              unselectedText: _vm.$t("Global.toolbar_Filters_Unselected"),
              allLabel: _vm.$t("ABCAnalysis.toolbar_Stores_AllLabel"),
              buttonText: _vm.$t("ABCAnalysis.toolbar_Stores_ButtonText"),
              buttonIconLeft: "btn-success",
            },
            on: {
              delegateCheckAll: _vm.onChangeSupplierFilter,
              delegateCheckItem: _vm.onChangeSupplierFilter,
              delegateSubmitItems: _vm.submitFilters,
            },
          }),
          _c("CustomCheckbox", {
            staticClass: "m-left-15",
            attrs: {
              id: "checkbox-approver-order-show-integration-messages",
              checked: _vm.showIntegrationMessages,
              label: _vm.$t("Orders.showIntegrationMessages"),
            },
            on: { change: _vm.changeShowIntegrationMessagesStatus },
          }),
        ],
        1
      ),
      _c(
        "template",
        { slot: "toolbar-right" },
        [
          _vm.hasTabPermission
            ? _c("ImportExport", {
                ref: "wrapper",
                attrs: {
                  componentName: "approvedOrder",
                  isDisabled: _vm.isFetchingPageData,
                  activeImportExports: ["export"],
                  downloadUrl: "Order/orderdetail/export",
                  downloadFileType: "xlsx",
                  downloadParams: _vm.downloadParams,
                  downloadFileName: _vm.downloadFileName,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "template",
        { slot: "content-center" },
        [
          !_vm.hasTabPermission ? _c("NoPermission") : _vm._e(),
          _vm.isFetchingPageData || _vm.isFetchingOrderList
            ? _c("TableLoading", { staticClass: "sticky" })
            : _vm._e(),
          _vm.isEmptyApproveOrderList &&
          !_vm.isFetchingPageData &&
          !_vm.isFetchingOrderList
            ? _c("EmptyState", {
                attrs: {
                  title: _vm.$t("Orders.orders_emptyState_NotFound_Title"),
                  description: _vm.$t(
                    "Orders.orders_emptyState_NotFound_Description"
                  ),
                },
              })
            : _vm._e(),
          _vm.isEmptyApproveOrderList ? _c("span") : _vm._e(),
          _vm.stockItem?.name
            ? _c("div", { staticClass: "selected-stock-item m-bottom-10" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("Orders.selectedStockItem") + ":")),
                ]),
                _c("span", { staticClass: "m-left-5" }, [
                  _vm._v(_vm._s(_vm.stockItem.name)),
                ]),
              ])
            : _vm._e(),
          !_vm.isEmptyApproveOrderList
            ? _c("TableView", {
                ref: "approvedOrderTable",
                attrs: {
                  fields: _vm.ordersHeaderFields,
                  data: _vm.approveOrders,
                  readOnly: true,
                  page: _vm.Page,
                  usePortalAction: true,
                },
                on: {
                  showExportPopup: _vm.showExportPopup,
                  delegateOnChangePage: _vm.changePage,
                  delegateOnChangePageSize: _vm.changePageSize,
                  delegateOnItemShow: _vm.showOrderDetail,
                },
              })
            : _vm._e(),
          _c("portal", {
            attrs: { to: "integrationStatusName" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return _c(
                    "div",
                    {},
                    [
                      _vm.hasOrderEdit
                        ? _c("CustomSelect", {
                            attrs: {
                              selectedEmitValue: "id",
                              optionTitle: "name",
                              defaultTitle: _vm.$t(
                                "Global.Multiselect_Unselected_Text"
                              ),
                              optionData: _vm.OrderIntegrationStatusList,
                              hoverFirstItem: false,
                              isDisabled: row.integrationStatusIsClosureStatus,
                            },
                            on: {
                              inputSelected: (value) =>
                                _vm.changeOrderType(row, value),
                            },
                            model: {
                              value: row.integrationStatusId,
                              callback: function ($$v) {
                                _vm.$set(row, "integrationStatusId", $$v)
                              },
                              expression: "row.integrationStatusId",
                            },
                          })
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                row.integrationStatusName
                                  ? row.integrationStatusName
                                  : "-"
                              )
                            ),
                          ]),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _c("portal", {
            attrs: { to: "single-action-portal-start" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return _c(
                    "div",
                    {},
                    [
                      row.totalUnitQuantityList.length > 0
                        ? _c("TotalPreview", {
                            attrs: {
                              rowIndex: row.rowIndex,
                              list: row.totalUnitQuantityList,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _c("portal", { attrs: { to: "checkboxAll" } }, [
            _c(
              "div",
              [
                _c("custom-checkbox", {
                  attrs: {
                    label: "",
                    checked: _vm.isSelectedAll,
                    disabled: !_vm.selectedSupplierId,
                  },
                  on: { change: _vm.toggleAll },
                }),
              ],
              1
            ),
          ]),
          _c("portal", {
            attrs: { to: "orderDate" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return _c(
                    "div",
                    {},
                    [
                      _c("CustomDatepicker", {
                        staticClass: "table-date-picker",
                        class: {
                          "is-danger": _vm.veeErrors.has(
                            `date-${row.rowIndex}`
                          ),
                        },
                        attrs: {
                          name: `date-${row.rowIndex}`,
                          id: `date-input-table-row-${row.rowIndex}`,
                          value: row.orderDate,
                          disabledStartDate: _vm.disableDate,
                          pickerType: "manuel",
                          inputIconRight: "",
                          disabled: row.status === 2,
                          inputIcon: "",
                        },
                        on: { change: (e) => _vm.changeOrderDate(row, e) },
                      }),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _c("portal", {
            attrs: { to: "resendButton" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return _c(
                    "div",
                    {},
                    [
                      _c("Button", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              (row.accountingStatus === 3 ||
                                row.wmsStatus === 3) &&
                              _vm.renderComponent,
                            expression:
                              "(row.accountingStatus === 3 || row.wmsStatus === 3) && renderComponent",
                          },
                        ],
                        staticClass: "icon-global-warning",
                        attrs: {
                          id: `orders-header-resend-button-${row.rowIndex}`,
                          iconName: "icon-global-warning",
                          justIcon: true,
                          clearVariant: true,
                          size: "medium",
                          isLoading: _vm.resendLoading,
                          disabled: _vm.resendLoading,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleErrorPopup(row)
                          },
                        },
                      }),
                      row.showAccountingStatus
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "shortkey",
                                  rawName: "v-shortkey",
                                  value: ["esc"],
                                  expression: "['esc']",
                                },
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: () => _vm.closeErrorPopup(row),
                                  expression: "() => closeErrorPopup(row)",
                                },
                              ],
                              staticClass: "MiniPopup right",
                            },
                            [
                              _c("div", { staticClass: "resendButton-Popup" }, [
                                row.accountingStatus === 3
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "resendButton-Popup-content",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(row.accountingMessage)),
                                        ]),
                                        _c(
                                          "Button",
                                          {
                                            staticClass: "m-left-10",
                                            attrs: {
                                              id: "approved-orders-header-resend-data",
                                              iconName: "icon-global-refresh",
                                              iconClass: "icon-global-refresh",
                                              secondary: "",
                                              size: "small",
                                              disabled: _vm.resendLoading,
                                              isLoading: _vm.resendLoading,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.requestOrderResend(
                                                  row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Orders.Resend_Button_Text"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                row.wmsStatus === 3
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "resendButton-Popup-content m-top-10",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(row.wmsMessage)),
                                        ]),
                                        _c(
                                          "Button",
                                          {
                                            staticClass: "m-left-10",
                                            attrs: {
                                              id: "approved-orders-header-resend-data-wms",
                                              iconName: "icon-global-refresh",
                                              iconClass: "icon-global-refresh",
                                              secondary: "",
                                              size: "small",
                                              disabled: _vm.isLoadingWMSReset,
                                              isLoading: _vm.isLoadingWMSReset,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.resendOrderForWMS(
                                                  row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Orders.Resend_Button_Text"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      row.accountingStatus !== 3 && row.wmsStatus !== 3
                        ? _c("span", [_vm._v("-")])
                        : _vm._e(),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _c("portal", {
            attrs: { to: "emailStatus" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return _c(
                    "div",
                    {},
                    [
                      !row.emailSentStatus
                        ? _c("span", [_vm._v("-")])
                        : _c(
                            "Button",
                            {
                              staticClass:
                                "show-MiniPopup relative width-max-content",
                              attrs: {
                                id: `orders-header-email-status-${row.rowIndex}`,
                                iconName: _vm.getEmailStatusIcon(
                                  row.emailSentStatus
                                ),
                                justIcon: true,
                                clearVariant: true,
                                size: "medium",
                              },
                            },
                            [
                              row.emailSentStatus === 2
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "MiniPopup-right-primary m-top-25 m-right-15 c-dark",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(row.emailErrorMessage)),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _c("portal", {
            attrs: { to: "description" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return _c(
                    "div",
                    {},
                    [
                      row.description
                        ? _c(
                            "Button",
                            {
                              staticClass:
                                "show-MiniPopup relative width-max-content btn-info",
                              attrs: {
                                id: `orders-header-info-button-${row.rowIndex}`,
                                iconName: "icon-global-info",
                                clearVariant: true,
                                justIcon: true,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "MiniPopup-right-primary m-top-15 c-dark",
                                },
                                [_c("span", [_vm._v(_vm._s(row.description))])]
                              ),
                            ]
                          )
                        : _c("span", [_vm._v(_vm._s("-"))]),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _c("portal", {
            attrs: { to: "actionPortal" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return _c(
                    "div",
                    { staticClass: "popup-container flexbox" },
                    [
                      _vm.renderComponent
                        ? _c("ActionButton", {
                            attrs: {
                              data: _vm.headerActions(row),
                              item: row,
                              customActionName: _vm.$t("Orders.resendEmail"),
                            },
                            on: {
                              onItemCustomAction: function ($event) {
                                return _vm.resendEmail(row)
                              },
                              onItemEdit: function ($event) {
                                return _vm.editAction(row)
                              },
                              onItemExport: function ($event) {
                                return _vm.showExportPopup(row)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _c("router-view", {
            on: {
              getOrdersHeaderAll: _vm.getOrdersHeaderAll,
              showOrderWithDetail: _vm.showOrderWithDetail,
            },
          }),
          _vm.isExportPopupVisible
            ? _c("exportPopup", {
                ref: "exportPopupTemplate",
                attrs: {
                  templateId: _vm.templateId,
                  templateType: _vm.templateType,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }